import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Membership() {
    const navigate = useNavigate()
    const location = useLocation();
    const data = [
      
        {
          img: '/images/corpo/pass1/silver-pass.jpg',
          title: 'SILVER PASS',
          items: ['List 1', 'List 2', 'List 3', 'List 4', 'List 5', 'List 6']
        },
        {
          img: '/images/corpo/pass1/gold-pass.jpg',
          title: 'GOLD PASS',
          items: ['Item A', 'Item B', 'Item C', 'Item D', 'Item E', 'Item F']
        },
        {
          img: '/images/corpo/pass1/platinum-pass.jpg',
          title: 'PLATINUM PASS',
          items: ['hello , pass 50% off  1', 'hello , pass 50% off  2', 'hello , pass 50% off  3', 'hello , pass 50% off  4', 'hello , pass 50% off  5', 'Item hell now pass 50% 6']
        },
      ];
     const join=()=>{
      navigate("/signup")
     }

//  scroll particulat secion 
     useEffect(() => {
       // Wait for content to render, then scroll
       if (location.hash) {
         const target = document.querySelector(location.hash);
         if (target) {
           setTimeout(() => {
             target.scrollIntoView({ behavior: 'smooth' });
           }, 100); // Give time for render
         }
       }
     }, [location]);
    
  return (

      
     <>
      {/* SEO for Membership Section */}
      <Helmet>
        <title>Membership Program at V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Join V Hotel The Grand Shoba's membership program to access exclusive discounts, earn rewards, and enjoy elevated experiences."
        />
        <meta name="keywords" content="V Hotel Membership, Membership Benefits, Loyalty Program, Exclusive Offers, V Hotel The Grand Shoba" />
        <link rel="canonical" href="https://www.vhotelthegrandshoba.com/corporate" />
      </Helmet>


     <div className="container" id='mebership'>
        <div className="container-fluid">
            {/* membership about */}
        

       {/* pass card */}
       <div className="membership-pass-card  " >
              <div className='membership-pass-card-left'>
             {/* <div className="exl-under"></div> */}
               <h1>MEMBERSHIP</h1>
            
             
            </div>
            <div className="membership-pass-card-right">
                <p>Welcome to  The Grand Shoba a Delhi of tailored privileges and benefits, designed to enhance and enrich your experience.</p>
            </div>
            </div>

      <div className="row">
      <div className="membership-image-section">
      {data.map((block, index) => (
        <div className="image-card col-md-4 col-sm-6 col-12" key={index}>
          <img src={block.img} title='V Hotel The Grnad Shoba Membership' loading='lazy' alt={`V Hotel The Grnad Shoba ${index + 1}`} />
          {/* <div className="membership-overlay">
            <h3>{block.title}</h3>
            <ul>
              {block.items.map((item, idx) => (
                <li key={idx}>{item}</li>
                ))}
                </ul>
                </div> */}
        </div>
      ))}
      </div>
      </div>

      <div className="membership-button">
       <button onClick={join} >Join Now</button>
      </div>


      {/* membership about */}
      <div className="membership-about mt-4">
         <div className="membership-about-heading">
             <h1>A WORLD OF</h1>
             <h1 className="membership-heading2 text-uppercase">Privileges And Benefits</h1>
             
         </div>
         <div className="membership-about-para">
         <p>Unlock a host of elevated experiences and countless rewards with the Shoba Pass loyalty program. Enjoy special room rates, earn and redeem Shoba Coins, and indulge in exceptional benefits on plush stays, exquisite dining, and more at V Hotel The Grand Shoba</p>
         </div>
        
       </div>

        </div>
     </div>

     {/* <Testimonials/> */}
      </>
  )
}
